import React, { useState } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import AppRouter from './Router';
import HeaderBar from './Components/FormComponents/HeaderBar';
import Navbar from './Components/Navbar';

const App = () => {

  return (
    <Router>
      <HeaderBar />
      <Navbar />
      <AppRouter />
    </Router>
  );
};

export default App;
